export const CHANGE_ACTIVE_PAGE = "CHANGE_ACTIVE_PAGE";
export const ANSWER_QUESTION = "ANSWER_QUESTION";
export const CHANGE_ACTIVE_QUESTION = "CHANGE_ACTIVE_QUESTION";
export const CHANGE_COUNT_TIMER = "CHANGE_COUNT_TIMER";
export const EXAM_INFO = "EXAM_INFO";
